import Loadable from 'react-loadable';

import { LoadingPageLoadable } from 'modules/main/pages/Loading';

export const ImportedListingPageContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "ImportedListingPageContainer" */
      './ImportedListingPageContainer.dynamic'
    ),
  loading: LoadingPageLoadable,
});
